export const getState = state => state.salesforce

export const getEmail = state => getState(state).email
export const getIsLoggedIn = state => getState(state).isLoggedIn
export const getRecents = state => getState(state).recents
export const getSearchResults = state => getState(state).search
export const getSearchText = state => getState(state).searchText
export const getSessionItems = sessionId => state => getState(state).mappings[sessionId]
export const getItemDetails = id => state => getState(state).records[id]
export const getHasSearchText = state => Boolean(getSearchText(state))
export const getIsSearching = state => getState(state).isSearching
export const getHasPermissions = state => getState(state).hasPermissions
